import { lazy } from 'react';
export var ProfilePageAsync = lazy(function () { return import('./ProfilePage'); });
